import React, { useEffect, useRef } from 'react';
import { useTimer } from 'react-timer-hook';

function Timer(props) {
    const intervalRef = useRef(null);

    const convertMsToTime = (ms) => {
        let seconds = Math.floor((ms / 1000) % 60);
        let minutes = Math.floor((ms / (1000 * 60)) % 60);
        let hours = Math.floor((ms / (1000 * 60 * 60)) % 24);

        return { seconds, minutes, hours };
    };

    const { hours, minutes, seconds } = convertMsToTime(props.duration);

    const expiryTimestamp = new Date();
    expiryTimestamp.setSeconds(expiryTimestamp.getSeconds() + Math.floor(props.duration / 1000));

    const {
        seconds: timerSeconds,
        minutes: timerMinutes,
        hours: timerHours,
    } = useTimer({
        expiryTimestamp,
        autoStart: true,
        onExpire: () => {
            console.log('Timer expired, auto-submitting test...');
            props.handleConfirmationSubmit(true); // Auto-submit test
        },
    });

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            console.log('checkpoint ');
            props.updateElapsedTime(30000);
        }, 30000); // 30 seconds interval

        return () => {
            clearInterval(intervalRef.current);
        };
    }, [props.updateElapsedTime]);


    return (
        <div>
            <div style={{ fontSize: 'medium' }}>
                <span>{timerHours}</span>:
                <span>{timerMinutes}</span>:
                <span>{timerSeconds}</span>
            </div>
        </div>
    );
}

export default Timer;